﻿<script setup lang="ts"></script>

<script lang="ts"></script>

<template>
    <div class="ai-intro">
        <div class="d-flex justify-content-center">
            <svg
                width="768"
                height="384"
                version="1.1"
                x="0px"
                y="0px"
                viewBox="0 0 384 192"
                xml:space="preserve"
                stroke-miterlimit="10"
                fill="none"
                stroke="none">
                <g id="bg">
                    <path
                        class="bg"
                        d="M364.5,52V24c0-2.5-2-4.5-4.5-4.5H204c-2.5,0-4.5,2-4.5,4.5v46H198v8h-4v-8h-1.5V50h-1v20H190v8h-4v-8h-1.5V34
            		c0-2.5-2-4.5-4.5-4.5h-44v1h44c1.9,0,3.5,1.6,3.5,3.5v36H182v8h-4v-8h-1.5V54c0-2.5-2-4.5-4.5-4.5h-52c-1.9,0-3.5-1.6-3.5-3.5V24
            		c0-2.5-2-4.5-4.5-4.5H20v1h92c1.9,0,3.5,1.6,3.5,3.5v22c0,2.5,2,4.5,4.5,4.5h52c1.9,0,3.5,1.6,3.5,3.5v16H174v8h-8v1.5H54
            		c-1.9,0-3.5-1.6-3.5-3.5V40h-1v36c0,2.5,2,4.5,4.5,4.5h112V82h8v4h-8v1.5H70v1h96V90h8v4h-8v1.5H94c-2.5,0-4.5,2-4.5,4.5v16
            		c0,1.9-1.6,3.5-3.5,3.5H40v1h46c2.5,0,4.5-2,4.5-4.5v-16c0-1.9,1.6-3.5,3.5-3.5h72V98h8v4h-8v1.5h-56v1h56v1.5h8v4h-8v1.5h-32
            		c-2.5,0-4.5,2-4.5,4.5v30c0,1.9-1.6,3.5-3.5,3.5H70v1h56c2.5,0,4.5-2,4.5-4.5v-30c0-1.9,1.6-3.5,3.5-3.5h32v1.5h8v8h1.5v24
            		c0,1.9-1.6,3.5-3.5,3.5h-22v1h22c2.5,0,4.5-2,4.5-4.5v-24h1.5v-8h4v8h1.5v46c0,1.9-1.6,3.5-3.5,3.5H24c-1.9,0-3.5-1.6-3.5-3.5v-28
            		h-1v28c0,2.5,2,4.5,4.5,4.5h156c2.5,0,4.5-2,4.5-4.5v-46h1.5v-8h4v8h1.5v28h1v-28h1.5v-8h4v8h1.5v36c0,2.5,2,4.5,4.5,4.5h44v-1h-44
            		c-1.9,0-3.5-1.6-3.5-3.5v-36h1.5v-8h4v8h1.5v16c0,2.5,2,4.5,4.5,4.5h52c1.9,0,3.5,1.6,3.5,3.5v22c0,2.5,2,4.5,4.5,4.5h92v-1h-92
            		c-1.9,0-3.5-1.6-3.5-3.5v-22c0-2.5-2-4.5-4.5-4.5h-52c-1.9,0-3.5-1.6-3.5-3.5v-16h1.5v-8h8v-1.5h112c1.9,0,3.5,1.6,3.5,3.5v36h1
            		v-36c0-2.5-2-4.5-4.5-4.5H218V110h-8v-4h8v-1.5h96v-1h-96V102h-8v-4h8v-1.5h72c2.5,0,4.5-2,4.5-4.5V76c0-1.9,1.6-3.5,3.5-3.5h46v-1
            		h-46c-2.5,0-4.5,2-4.5,4.5v16c0,1.9-1.6,3.5-3.5,3.5h-72V94h-8v-4h8v-1.5h56v-1h-56V86h-8v-4h8v-1.5h32c2.5,0,4.5-2,4.5-4.5V46
            		c0-1.9,1.6-3.5,3.5-3.5h56v-1h-56c-2.5,0-4.5,2-4.5,4.5v30c0,1.9-1.6,3.5-3.5,3.5h-32V78h-8v-8h-1.5V46c0-1.9,1.6-3.5,3.5-3.5h22
            		v-1h-22c-2.5,0-4.5,2-4.5,4.5v24H206v8h-4v-8h-1.5V24c0-1.9,1.6-3.5,3.5-3.5h156c1.9,0,3.5,1.6,3.5,3.5v28H364.5z M198,82v4h-4v-4
            		H198z M190,98v4h-4v-4H190z M186,94v-4h4v4H186z M194,98h4v4h-4V98z M194,94v-4h4v4H194z M190,82v4h-4v-4H190z M178,82h4v4h-4V82z
            		 M178,90h4v4h-4V90z M178,98h4v4h-4V98z M178,110v-4h4v4H178z M186,110v-4h4v4H186z M194,110v-4h4v4H194z M206,110h-4v-4h4V110z
            		 M206,102h-4v-4h4V102z M206,94h-4v-4h4V94z M206,82v4h-4v-4H206z" />
                </g>
                <g id="lines">
                    <line class="line" x1="192" y1="122" x2="192" y2="150" />
                    <line class="line" x1="192" y1="70" x2="192" y2="50" />
                    <path class="line" d="M176,122v24c0,2.2-1.8,4-4,4h-22" />
                    <line class="line" x1="166" y1="88" x2="70" y2="88" />
                    <path class="line-3" d="M166,96H94c-2.2,0-4,1.8-4,4v16c0,2.2-1.8,4-4,4H40" />
                    <line class="line" x1="166" y1="104" x2="110" y2="104" />
                    <path class="line-2" d="M184,122v46c0,2.2-1.8,4-4,4H24c-2.2,0-4-1.8-4-4l0-28" />
                    <path class="line" d="M166,112h-32c-2.2,0-4,1.8-4,4v30c0,2.2-1.8,4-4,4H70" />
                    <path class="line-1" d="M176,70V54c0-2.2-1.8-4-4-4h-52c-2.2,0-4-1.8-4-4l0-22c0-2.2-1.8-4-4-4H20" />
                    <path class="line" d="M184,70V34c0-2.2-1.8-4-4-4h-44" />
                    <path class="line-4" d="M166,80H54c-2.2,0-4-1.8-4-4V40" />
                    <path class="line" d="M208,70V46c0-2.2,1.8-4,4-4h22" />
                    <line class="line" x1="218" y1="104" x2="314" y2="104" />
                    <path class="line-3 mirrored" d="M218,96h72c2.2,0,4-1.8,4-4V76c0-2.2,1.8-4,4-4h46" />
                    <line class="line" x1="218" y1="88" x2="274" y2="88" />
                    <path class="line-2 mirrored" d="M200,70V24c0-2.2,1.8-4,4-4h156c2.2,0,4,1.8,4,4v28" />
                    <path class="line" d="M218,80h32c2.2,0,4-1.8,4-4V46c0-2.2,1.8-4,4-4h56" />
                    <path class="line-1 mirrored" d="M208,122v16c0,2.2,1.8,4,4,4h52c2.2,0,4,1.8,4,4v22c0,2.2,1.8,4,4,4h92" />
                    <path class="line" d="M200,122v36c0,2.2,1.8,4,4,4h44" />
                    <path class="line-4 mirrored" d="M218,112h112c2.2,0,4,1.8,4,4v36" />
                </g>
                <g id="chip">
                    <path class="chip" d="M212,120h-40c-2.2,0-4-1.8-4-4V76c0-2.2,1.8-4,4-4h40c2.2,0,4,1.8,4,4v40C216,118.2,214.2,120,212,120z" />
                </g>
                <g id="dots">
                    <circle class="dot" cx="20" cy="20" r="2" />
                    <circle class="dot" cx="20" cy="140" r="2" />
                    <circle class="dot" cx="40" cy="120" r="2" />
                    <circle class="dot" cx="50" cy="40" r="2" />
                    <circle class="dot" cx="70" cy="88" r="2" />
                    <circle class="dot" cx="110" cy="104" r="2" />
                    <circle class="dot" cx="70" cy="150" r="2" />
                    <circle class="dot" cx="150" cy="150" r="2" />
                    <circle class="dot" cx="136" cy="30" r="2" />
                    <circle class="dot" cx="192" cy="50" r="2" />
                    <circle class="dot" cx="192" cy="150" r="2" />
                    <circle class="dot" cx="364" cy="172" r="2" />
                    <circle class="dot" cx="364" cy="52" r="2" />
                    <circle class="dot" cx="344" cy="72" r="2" />
                    <circle class="dot" cx="334" cy="152" r="2" />
                    <circle class="dot" cx="314" cy="104" r="2" />
                    <circle class="dot" cx="274" cy="88" r="2" />
                    <circle class="dot" cx="314" cy="42" r="2" />
                    <circle class="dot" cx="234" cy="42" r="2" />
                    <circle class="dot" cx="248" cy="162" r="2" />
                </g>
                <g id="logo">
                    <path
                        class="logo"
                        d="M198,95.7V96c0,3.3-2.7,6-6,6c-3.3,0-6-2.7-6-6v-6.7c0-0.4-0.3-0.8-0.7-0.8c-0.4,0-0.8,0.3-0.8,0.8V96
                		c0,4.1,3.4,7.5,7.5,7.5c4.1,0,7.5-3.4,7.5-7.5v-6.7c0-0.4-0.3-0.8-0.7-0.8c-0.4,0-0.8,0.3-0.8,0.8v2.5c0,0.4-0.4,0.7-0.8,0.7
                		c-0.4,0-0.7-0.3-0.7-0.7c0,0,0-2.5,0-2.5c0-1.2,1-2.3,2.2-2.3c1.2,0,2.3,1,2.3,2.3V96c0,5-4,9-9,9c-5,0-9-4-9-9v-6.7
                		c0-1.2,1-2.3,2.3-2.3c1.2,0,2.2,1,2.2,2.3V96c0,2.5,2,4.5,4.5,4.5c2.5,0,4.5-2,4.5-4.5v-0.3c0-0.4-0.3-0.7-0.7-0.7
                		c-0.4,0-0.8,0.3-0.8,0.7c0,0,0,0.3,0,0.3c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3v-6.7c0-2.1-1.7-3.7-3.7-3.7c-2.1,0-3.8,1.7-3.8,3.7V96
                		c0,5.8,4.7,10.5,10.5,10.5c5.8,0,10.5-4.7,10.5-10.5v-6.7c0-2.1-1.7-3.7-3.8-3.7c-2.1,0-3.7,1.7-3.7,3.7v2.5c0,0.4-0.3,0.7-0.7,0.7
                		c-0.4,0-0.8-0.3-0.8-0.7c0,0,0-2.5,0-2.5c0-2.9,2.4-5.3,5.2-5.3c2.9,0,5.3,2.4,5.3,5.3V96c0,6.6-5.4,12-12,12c-6.6,0-12-5.4-12-12
                		v-6.7c0-2.9,2.4-5.3,5.3-5.3s5.2,2.4,5.2,5.3V96c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5v-0.3c0-1.2,1-2.2,2.3-2.2
                		C197,93.5,198,94.5,198,95.7" />
                </g>
            </svg>
        </div>
    </div>
</template>

<style lang="less">
    .ai-intro {
        --line-dash: 20;
        --line-1-gap: 220;
        --line-1-stop: 260;
        --line-2-gap: 262;
        --line-2-stop: 302;
        --line-3-gap: 166;
        --line-3-stop: 206;
        --line-4-gap: 154;
        --line-4-stop: 194;

        animation: fade-in-out 4000ms linear 0ms 1;
        opacity: 0;

        @keyframes fade-in-out {
            0% {
                opacity: 0;
            }
            10% {
                opacity: 1;
            }
            90% {
                opacity: 1;
            }
            100% {
                opacity: 0;
            }
        }

        #lines > :not(.line) {
            stroke-dashoffset: var(--line-dash);
            stroke: #1fa9b0;
            filter: drop-shadow(0px 0px 1px #1fa9b0);
        }

        .line-1,
        .line-1.mirrored {
            stroke-dasharray: var(--line-dash) var(--line-1-gap);
        }

        .line-1 {
            animation: lineflow-1 2500ms ease-in-out 500ms 1;
        }

        .line-1.mirrored {
            animation: lineflow-1 3000ms ease-in-out 0ms 1;
        }

        .line-2,
        .line-2.mirrored {
            stroke-dasharray: var(--line-dash) var(--line-2-gap);
        }

        .line-2 {
            animation: lineflow-2 2500ms ease-in-out 1000ms 1;
        }

        .line-2.mirrored {
            animation: lineflow-2 2000ms ease-in-out 0ms 1;
        }

        .line-3,
        .line-3.mirrored {
            stroke-dasharray: var(--line-dash) var(--line-3-gap);
        }

        .line-3 {
            animation: lineflow-3 2000ms ease-in-out 500ms 1;
        }

        .line-3.mirrored {
            animation: lineflow-3 2000ms ease-in-out 1000ms 1;
        }

        .line-4,
        .line-4.mirrored {
            stroke-dasharray: var(--line-dash) var(--line-4-gap);
        }

        .line-4 {
            animation: lineflow-4 2500ms ease-in-out 500ms 1;
        }

        .line-4.mirrored {
            animation: lineflow-4 1500ms ease-in-out 1500ms 1;
        }

        @keyframes lineflow-1 {
            0% {
                stroke-dashoffset: var(--line-dash);
            }

            100% {
                stroke-dashoffset: var(--line-1-stop);
            }
        }

        @keyframes lineflow-2 {
            0% {
                stroke-dashoffset: var(--line-dash);
            }

            100% {
                stroke-dashoffset: var(--line-2-stop);
            }
        }

        @keyframes lineflow-3 {
            0% {
                stroke-dashoffset: var(--line-dash);
            }

            100% {
                stroke-dashoffset: var(--line-3-stop);
            }
        }

        @keyframes lineflow-4 {
            0% {
                stroke-dashoffset: var(--line-dash);
            }

            100% {
                stroke-dashoffset: var(--line-4-stop);
            }
        }

        .chip {
            fill: #1f1c26;
        }

        .logo {
            fill: #1fa9b0;
        }

        .dot {
            fill: #ffffff;
            stroke: #1fa9b0;
        }

        .bg {
            fill: #ccc;
        }

        .line {
            display: none;
        }
    }
</style>

<style scoped lang="less"></style>
